qaPresenter.directive('qaPresenter', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'qa_presenter/templates/' + helperService.getRedesignPathPrefix() + 'qaPresenter.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
